














































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import Delivery from '@/dto/deliveries/Delivery'
import { ErrorsResponse } from '@/dto/ErrorsResponse'
import deliveryStore from '@/stores/DeliveryStore'
import { Routes } from '@/router/routes'
import createDeliveryStore from '@/stores/CreateDeliveryStore'

@Component
export default class PreferencesFooter extends Vue {
  @Prop(Object)
  model: Delivery
  deliveryStore = deliveryStore
  createDeliveryStore = createDeliveryStore
  isPending: boolean = false
  showConfirmDialog: boolean = false
  isDisabledBtn = true

  async saveDelivery() {
    this.isPending = true
    const delivery = await this.deliveryStore
      .saveDelivery(this.model)
      .catch(errors => this.emitErrors(errors))
    this.isPending = false

    if (delivery && this.model.id === null) {
      this.goToEditPage(delivery.id as number)
    }
  }

  goToEditPage(deliveryId: number) {
    this.$router.push({
      name: Routes.deliveryEdit,
      params: { deliveryId: deliveryId.toString() },
    })
  }

  removeDelivery() {
    if (!this.model.id) {
      return
    }

    this.isPending = true

    this.$router.push({
      name: Routes.deliveries,
    })

    this.deliveryStore.removeDelivery(this.model.id).finally(() => {
      this.isPending = false
    })
  }

  cloneDelivery() {
    this.createDeliveryStore.setFromExistModel(this.model).then(() => {
      this.$router.push({ name: Routes.deliveryCreate })
    })
  }

  emitErrors(errors: ErrorsResponse) {
    this.$emit('error', errors)
  }

  @Watch('model', { deep: true })
  watchFields(model: Delivery, oldModel: Delivery) {
    this.isDisabledBtn = model.id !== oldModel.id
  }
}
